import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const EventCommentApi = createApi({
  reducerPath: "eventCommentApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["eventcomment"],
  endpoints: (builder) => ({
    getEventComment: builder.query({
      query: ({ eventId, MAX_SAFEST_INTEGER }) => ({
        url: `/event/comments/${String(eventId)}?pageSize=${String(
          MAX_SAFEST_INTEGER
        )}`,
        method: "GET"
      })
    })
  })
});

export const { useGetEventCommentQuery, useLazyGetEventCommentQuery } =
  EventCommentApi;
